import React from "react";
import PropTypes from "prop-types";
import Head from "next/head";
import { useRouter } from "next/router";
import { Provider } from "react-redux";
import { store } from "@/redux/store";

const EmptyLayout = ({ children }) => {
  const router = useRouter();
  const isHiringManagerPortal = router?.pathname?.startsWith("/hiring-manager-portal");
  const pageTitle = isHiringManagerPortal
    ? "ANSR 1Connect - Hiring Manager"
    : "ANSR 1Connect - Candidate";

  return (
    <>
      <Head>
        <link rel="icon" href="/images/favicon.ico" />
        <title>{pageTitle}</title>
      </Head>
      <Provider store={store}>
      {children}
      </Provider>
    </>
  );
};

EmptyLayout.propTypes = {
  children: PropTypes.node,
};

export default EmptyLayout;
